import { render, staticRenderFns } from "./subscription-section.vue?vue&type=template&id=515a8445&scoped=true&"
import script from "./subscription-section.vue?vue&type=script&lang=js&"
export * from "./subscription-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515a8445",
  null
  
)

export default component.exports